import BaseObject from '../../base/base_object';
import {ANALYTICS} from './navbar_const';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';

export default class AnalyticsTrigger extends BaseObject {
    static CLASS = "AnalyticsTrigger";

    init(params) {
        this._isReal = params.isReal;
        this._gameType = params.gameType;
        this._gameName = params.gameName;
    }
    send(action) {
        let analyticsObj = this.getAnalyticsObject(action);
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticsObj);
    }

    getAnalyticsObject(action) {
        let category = this._isReal ? ANALYTICS.CATEGORY.REAL : ANALYTICS.CATEGORY.ANONYMOUS;
        let label = this._gameType + '_' + this._gameName.replace(/ /g, '');
        return {category: category, action: action, label: label};
    }


}